import { Animation2D } from '../components/Animation2D';
import { Animation3D } from '../components/Animation3D';
(new Animation2D()).init();
(new Animation3D()).init();
